import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group col-sm-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "numero" }, "Numéro", -1 /* HOISTED */)
const _hoisted_3 = ["readonly"]
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = { class: "form-group col-sm-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "statut" }, "Statut", -1 /* HOISTED */)
const _hoisted_7 = {
  id: "statut",
  class: "form-control disabled"
}
const _hoisted_8 = { class: "form-group col-sm-4" }
const _hoisted_9 = { class: "d-inline-block" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "infosLegales.reglementModifieUnAutre"
}, " Ce règlement en modifie un autre ", -1 /* HOISTED */)
const _hoisted_12 = { class: "d-inline-block" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "infosLegales.subventionGouvernementale"
}, " Ce règlement fait l'objet d'une subvention gouvernementale ", -1 /* HOISTED */)
const _hoisted_15 = {
  key: 0,
  class: "form-group col-sm-3"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "numeroReglementModifie" }, "Numéro du règlement modifié", -1 /* HOISTED */)
const _hoisted_17 = { class: "form-group col-sm-12" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "objet" }, "Objet", -1 /* HOISTED */)
const _hoisted_19 = ["readonly"]
const _hoisted_20 = { class: "textarea-print" }
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = { class: "card mt-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Approbation des PHV", -1 /* HOISTED */)
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "form-group col-sm-4 label-nb-phv" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "approbationPHV.type",
  class: "form-label-base"
}, "L'approbation des PHV est-elle requise ? Sinon, veuillez indiquer s'il sagit d'une renonciation ou d'une exemption.", -1 /* HOISTED */)
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 0,
  class: "form-group col-sm-12"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "approbationPHV.motifExemption" }, " Motif d'exemption ", -1 /* HOISTED */)
const _hoisted_31 = ["readonly"]
const _hoisted_32 = { class: "textarea-print" }
const _hoisted_33 = {
  key: 1,
  class: "col-sm-12 mt-2"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  for: "approbationPHV.nbPHVNécessaires",
  class: "me-2 col-form-label col-sm-4 label-nb-phv"
}, " Nombre de personnes habiles à voter nécessaires à la tenue d'un scrutin ", -1 /* HOISTED */)
const _hoisted_35 = { class: "form-group col-sm" }
const _hoisted_36 = ["readonly"]
const _hoisted_37 = {
  key: 0,
  class: "col-sm-4 d-inline-block col-form-label aide-phv"
}
const _hoisted_38 = {
  key: 2,
  class: "col-sm-12 mt-2"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  for: "approbationPHV.nbSignatures",
  class: "me-2 col-form-label col-sm-4 label-nb-phv"
}, " Nombre de signatures recueillies lors de la tenue de registre ", -1 /* HOISTED */)
const _hoisted_40 = { class: "form-group col-sm" }
const _hoisted_41 = ["readonly"]
const _hoisted_42 = {
  key: 0,
  class: "col-sm-4 d-inline-block col-form-label aide-phv"
}
const _hoisted_43 = {
  key: 3,
  class: "col-sm-12 mt-2"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "approbationPHV.nbJoursRegistre",
  class: "me-2 col-form-label col-sm-4 label-nb-phv"
}, " Nombre de jours de tenue de registre ", -1 /* HOISTED */)
const _hoisted_45 = { class: "form-group col-sm" }
const _hoisted_46 = ["readonly"]
const _hoisted_47 = { class: "mt-4" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "approbationPHV.avis30Jours"
}, " Ce règlement a fait l'objet d'un avis de 30 jours ", -1 /* HOISTED */)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { class: "fst-italic" }, " Saisissez la date de chaque événement, au fur et à mesure ou elles sont connues. ", -1 /* HOISTED */)
const _hoisted_51 = { class: "table" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Événement"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Directives")
  ])
], -1 /* HOISTED */)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", null, "Dépot du projet de règlement", -1 /* HOISTED */)
const _hoisted_54 = ["readonly"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", null, "Avis de motion", -1 /* HOISTED */)
const _hoisted_57 = ["readonly"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("td", null, "Adoption du projet de règlement", -1 /* HOISTED */)
const _hoisted_60 = ["readonly"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", null, " Au plus tôt le deuxième jour ouvrable suivant la dernière des séances durant laquelle a été donné l'avis de motion ou déposé le projet de règlement. ", -1 /* HOISTED */)
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", null, "Publication d'un avis pour l'approbation des PHV", -1 /* HOISTED */)
const _hoisted_64 = ["readonly"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", null, " Au plus tard le cinquième jour ouvrable qui précède la première journée de tenue du registre. ", -1 /* HOISTED */)
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", null, "Première journée de tenue de registre", -1 /* HOISTED */)
const _hoisted_68 = ["readonly"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", null, " La tenue du registre doit être effectuée dans la période de 45 jours qui suit l'adoption du projet de règlement. ", -1 /* HOISTED */)
const _hoisted_70 = { key: 2 }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", null, "Certificat de publication", -1 /* HOISTED */)
const _hoisted_72 = ["readonly"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_74 = { key: 3 }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("td", null, "Avis de renonciation", -1 /* HOISTED */)
const _hoisted_76 = ["readonly"]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_78 = { key: 4 }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("td", null, "Avis public de 30 jours", -1 /* HOISTED */)
const _hoisted_80 = ["readonly"]
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    title: "Informations légales",
    "forced-opened": _ctx.forcedOpened,
    opened: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: _normalizeClass(["form-control", _ctx.triedSave && !_ctx.reglement.infosLegales.numero ? 'is-invalid' : '']),
          id: "numero",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reglement.infosLegales.numero) = $event)),
          maxlength: "17",
          readonly: _ctx.readonly
        }, null, 10 /* CLASS, PROPS */, _hoisted_3), [
          [_vModelText, _ctx.reglement.infosLegales.numero]
        ]),
        (_ctx.triedSave && !_ctx.reglement.infosLegales.numero)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.messagesValidation.numero), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.reglement.statut), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "form-check-input",
            disabled: _ctx.readonly,
            id: "infosLegales.reglementModifieUnAutre",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reglement.infosLegales.reglementModifieUnAutre) = $event)),
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onReglementModifieUnAutreChange && _ctx.onReglementModifieUnAutreChange(...args)))
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_10), [
            [_vModelCheckbox, _ctx.reglement.infosLegales.reglementModifieUnAutre]
          ]),
          _hoisted_11
        ]),
        _createElementVNode("span", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "form-check-input",
            disabled: _ctx.readonly,
            id: "infosLegales.subventionGouvernementale",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reglement.infosLegales.subventionGouvernementale) = $event)),
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onReglementModifieUnAutreChange && _ctx.onReglementModifieUnAutreChange(...args)))
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_13), [
            [_vModelCheckbox, _ctx.reglement.infosLegales.subventionGouvernementale]
          ]),
          _hoisted_14
        ])
      ]),
      (_ctx.reglement.infosLegales.reglementModifieUnAutre)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "numero",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reglement.infosLegales.numeroReglementModifie) = $event)),
              maxlength: "17"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.reglement.infosLegales.numeroReglementModifie]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _withDirectives(_createElementVNode("textarea", {
          type: "text",
          class: _normalizeClass(["form-control", _ctx.triedSave && !_ctx.reglement.infosLegales.objet ? 'is-invalid' : '']),
          id: "objet",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.reglement.infosLegales.objet) = $event)),
          rows: "3",
          readonly: _ctx.readonly
        }, null, 10 /* CLASS, PROPS */, _hoisted_19), [
          [_vModelText, _ctx.reglement.infosLegales.objet]
        ]),
        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.reglement.infosLegales.objet), 1 /* TEXT */),
        (_ctx.triedSave && !_ctx.reglement.infosLegales.objet)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.messagesValidation.objet), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              id: "approbationPHV.type",
              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onTypeApprobationPHVChange && _ctx.onTypeApprobationPHVChange(...args))),
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.reglement.approbationPHV.type) = $event)),
              disabled: _ctx.readonly
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TypeApprobationPHV, (typeAppro) => {
                return (_openBlock(), _createElementBlock("option", { value: typeAppro }, _toDisplayString(typeAppro), 9 /* TEXT, PROPS */, _hoisted_28))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_27), [
              [_vModelSelect, _ctx.reglement.approbationPHV.type]
            ])
          ]),
          (_ctx.reglement.approbationPHV.type === _ctx.TypeApprobationPHV.Exemption)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _hoisted_30,
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  class: "form-control",
                  id: "approbationPHV.motifExemption",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.reglement.approbationPHV.motifExemption) = $event)),
                  readonly: _ctx.readonly
                }, null, 8 /* PROPS */, _hoisted_31), [
                  [_vModelText, _ctx.reglement.approbationPHV.motifExemption]
                ]),
                _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.reglement.approbationPHV.motifExemption), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.reglement.approbationPHV.type === _ctx.TypeApprobationPHV.Oui)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control input-print-keep-margin",
                    readonly: _ctx.readonly,
                    min: "1",
                    step: "1",
                    onKeypress: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.Helpers.allowOnlyNumbers && _ctx.Helpers.allowOnlyNumbers(...args))),
                    onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.reglement.approbationPHV.nbPHVNécessaires = Math.floor(_ctx.reglement.approbationPHV.nbPHVNécessaires))),
                    id: "approbationPHV.nbPHVNécessaires",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.reglement.approbationPHV.nbPHVNécessaires) = $event))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_36), [
                    [_vModelText, _ctx.reglement.approbationPHV.nbPHVNécessaires]
                  ])
                ]),
                (_ctx.Helpers.getNbJrsRegistre(_ctx.reglement))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, " Le registre de signatures doit être tenu pendant " + _toDisplayString(_ctx.Helpers.getNbJrsRegistre(_ctx.reglement)) + " jour(s). ", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.reglement.approbationPHV.type === _ctx.TypeApprobationPHV.Oui)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control input-print-keep-margin",
                    readonly: _ctx.readonly,
                    min: "1",
                    step: "1",
                    onKeypress: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.Helpers.allowOnlyNumbers && _ctx.Helpers.allowOnlyNumbers(...args))),
                    onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.reglement.approbationPHV.nbSignatures = Math.floor(_ctx.reglement.approbationPHV.nbSignatures))),
                    id: "approbationPHV.nbSignatures",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.reglement.approbationPHV.nbSignatures) = $event))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_41), [
                    [_vModelText, _ctx.reglement.approbationPHV.nbSignatures]
                  ])
                ]),
                (_ctx.getNbSignaturesRequises(_ctx.reglement))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.getNbSignaturesRequises(_ctx.reglement)) + " signatures sont requises pour la tenue d'un scrutin référendaire. ", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.reglement.approbationPHV.type === _ctx.TypeApprobationPHV.Oui)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control input-print-keep-margin",
                    readonly: _ctx.readonly,
                    min: "1",
                    step: "1",
                    onKeypress: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.Helpers.allowOnlyNumbers && _ctx.Helpers.allowOnlyNumbers(...args))),
                    onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.reglement.approbationPHV.nbJoursRegistre = Math.floor(_ctx.reglement.approbationPHV.nbJoursRegistre))),
                    id: "approbationPHV.nbJoursRegistre",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.reglement.approbationPHV.nbJoursRegistre) = $event))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_46), [
                    [_vModelText, _ctx.reglement.approbationPHV.nbJoursRegistre]
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_47, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-check-input",
              disabled: _ctx.readonly,
              id: "approbationPHV.avis30Jours",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.reglement.approbationPHV.avis30Jours) = $event)),
              onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onReglementModifieUnAutreChange && _ctx.onReglementModifieUnAutreChange(...args)))
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_48), [
              [_vModelCheckbox, _ctx.reglement.approbationPHV.avis30Jours]
            ]),
            _hoisted_49
          ])
        ])
      ]),
      _hoisted_50,
      _createElementVNode("table", _hoisted_51, [
        _hoisted_52,
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_53,
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.reglement.evenements.depotProjet) = $event)),
                readonly: _ctx.readonly
              }, null, 8 /* PROPS */, _hoisted_54), [
                [_vModelText, _ctx.reglement.evenements.depotProjet]
              ])
            ]),
            _hoisted_55
          ]),
          _createElementVNode("tr", null, [
            _hoisted_56,
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control",
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.reglement.evenements.avisMotion) = $event)),
                readonly: _ctx.readonly
              }, null, 8 /* PROPS */, _hoisted_57), [
                [_vModelText, _ctx.reglement.evenements.avisMotion]
              ])
            ]),
            _hoisted_58
          ]),
          _createElementVNode("tr", null, [
            _hoisted_59,
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control",
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.reglement.evenements.adoptionProjet) = $event)),
                readonly: _ctx.readonly
              }, null, 8 /* PROPS */, _hoisted_60), [
                [_vModelText, _ctx.reglement.evenements.adoptionProjet]
              ])
            ]),
            _hoisted_61
          ]),
          (_ctx.reglement.approbationPHV.type === _ctx.TypeApprobationPHV.Oui)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    readonly: _ctx.readonly,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.reglement.evenements.publicationAvisApprobationPHV) = $event))
                  }, null, 8 /* PROPS */, _hoisted_64), [
                    [_vModelText, _ctx.reglement.evenements.publicationAvisApprobationPHV]
                  ])
                ]),
                _hoisted_65
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.reglement.approbationPHV.type === _ctx.TypeApprobationPHV.Oui)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_66, [
                _hoisted_67,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    readonly: _ctx.readonly,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.reglement.evenements.premiereJourneeRegistre) = $event))
                  }, null, 8 /* PROPS */, _hoisted_68), [
                    [_vModelText, _ctx.reglement.evenements.premiereJourneeRegistre]
                  ])
                ]),
                _hoisted_69
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.reglement.approbationPHV.type === _ctx.TypeApprobationPHV.Oui)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.reglement.evenements.certificatPublication) = $event)),
                    readonly: _ctx.readonly
                  }, null, 8 /* PROPS */, _hoisted_72), [
                    [_vModelText, _ctx.reglement.evenements.certificatPublication]
                  ])
                ]),
                _hoisted_73
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.reglement.approbationPHV.type === _ctx.TypeApprobationPHV.Renonciation)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.reglement.evenements.avisRenonciation) = $event)),
                    readonly: _ctx.readonly
                  }, null, 8 /* PROPS */, _hoisted_76), [
                    [_vModelText, _ctx.reglement.evenements.avisRenonciation]
                  ])
                ]),
                _hoisted_77
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.reglement.approbationPHV.avis30Jours)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_78, [
                _hoisted_79,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.reglement.evenements.avis30jours) = $event)),
                    readonly: _ctx.readonly
                  }, null, 8 /* PROPS */, _hoisted_80), [
                    [_vModelText, _ctx.reglement.evenements.avis30jours]
                  ])
                ]),
                _hoisted_81
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["forced-opened"]))
}